import type { ComponentProps } from "react"
import type { ProjectStatus } from "~/lib/enums"
import { enumFormat } from "~/lib/utils"
import { IssuePropertyIcon } from "./IssuePropertyIcon"

const projectStatusColors = {
	Planned: "light-dark(#64748b, #a3adbd)",
	InProgress: "light-dark(#a16207, #e8bd62)",
	Paused: "light-dark(#6d28d9, #b69aef)",
	Complete: "light-dark(#047857, #6acba2)",
	Canceled: "light-dark(#64748b, #a3adbd)"
} satisfies Record<ProjectStatus, string>

export function ProjectStatusIcon({
	status,
	...props
}: Omit<ComponentProps<"svg">, "color"> & {
	status: ProjectStatus
	withText?: boolean
}) {
	return (
		<IssuePropertyIcon
			label={enumFormat(status)}
			color={projectStatusColors[status]}
			{...props}
		>
			<rect
				x="2.25"
				y="2.25"
				width="11.5"
				height="11.5"
				rx="1.5"
				fill="currentColor"
				fillOpacity={status === "Complete" || status === "Paused" ? 0.12 : 0}
			/>
			{status === "InProgress" && (
				<path d="M8 4.25h3.5v7.5H8Z" fill="currentColor" stroke="none" />
			)}
			{status === "Paused" && (
				<path d="M6.25 5.5v5m3.5-5v5" strokeWidth="1.75" />
			)}
			{status === "Complete" && <path d="m5.25 8 1.8 1.8 3.7-3.7" />}
			{status === "Canceled" && <path d="m5.75 5.75 4.5 4.5m0-4.5-4.5 4.5" />}
		</IssuePropertyIcon>
	)
}
